<template>
  <div>
    <v-system-bar app color="white" flat height="50px" class="app-bar">
      <router-link :to="{ name: 'home' }" exact style="text-decoration: none">
        <a class="navbar-brand logo"><span class="mr-1">Pro</span>Editor</a>
      </router-link>
      <v-tabs right color="grey darken-1" :key="keyTabBar">
        <v-tab
          v-if="userData && userData.username === 'admin'"
          @click="onClickServerRender"
        >
          <v-icon size="20">mdi-bell-ring</v-icon>
        </v-tab>
        <v-tab
          class="hover-header-title"
          v-for="link in listHeaderTitle"
          :key="link.text"
          :to="link.path"
        >
          <v-icon
            class="hidden-sm-and-up"
            style="font-size: 24px"
            v-text="link.icon"
          ></v-icon>
          <span
            class="hidden-xs-and-down "
            v-if="$vuetify.breakpoint.smAndUp"
            >{{ link.text }}</span
          >
        </v-tab>
      </v-tabs>
      <v-btn v-if="$store.state.isUserLoggedIn && userData" icon :to="'/user'">
        <v-avatar
          v-if="userData && userData.avatar"
          class="mx-2"
          style="cursor: pointer"
          size="32"
        >
          <img
            class="avatar"
            :src="userData && userData.avatar"
            alt=""
            srcset=""
          />
        </v-avatar>
        <v-avatar
          v-else
          class="mx-2"
          style="cursor: pointer"
          color="rgb(0, 152, 253)"
          size="32"
        >
          <span class="white--text title text-uppercase" v-if="userData.name">{{
            userData.name.charAt(0)
          }}</span>
        </v-avatar>
      </v-btn>
    </v-system-bar>
    <v-navigation-drawer
      width="400"
      v-model="isShowInfoServer"
      absolute
      bottom
      temporary
      right
      class="px-2"
    >
      <div class="text-center my-2 mb-3 mt-3" style="position: relative">
        <h3 class="font-weight-bold">Thông tin Server</h3>
      </div>
      <div>
        <h5>
          Số Video Đang Chờ Render:
          <span
            class="font-weight-bold text-primary mx-2"
            style="font-size: 25px"
            >{{ listVideoQueuing.length }}</span
          >
          <v-icon
            v-if="!isShowVideoQueuing"
            @click="isShowVideoQueuing = true"
            class="icon-show-detail mx-2"
            >mdi-chevron-down-circle</v-icon
          >
          <v-icon
            v-else
            @click="isShowVideoQueuing = false"
            class="icon-hide-detail mx-2"
          >
            mdi-chevron-up-circle
          </v-icon>
        </h5>
        <table
          v-if="isShowVideoQueuing && listVideoQueuing"
          class="table table-hover table-bordered table-sm text-center"
        >
          <thead>
            <th>ID Video</th>
            <th>Tên tài khoản</th>
          </thead>
          <tr v-for="(video, i) in listVideoQueuing" :key="i">
            <td>
              {{ video._id }}
            </td>
            <td>
              {{ video.username }}
            </td>
          </tr>
        </table>
      </div>
      <div>
        <div
          v-for="(item, index) in listServer"
          :key="index"
          class="item-server"
        >
          <h5 class="font-weight-bold ">
            <a :href="item.domain">{{ `${item.name} ` }} </a>
            <v-icon v-if="item && item.data" class="icon-live">
              mdi-heart
            </v-icon>
            <v-icon v-else class="icon-die">
              mdi-heart-outline
            </v-icon>
          </h5>
          <table>
            <tr>
              <td>Video đang render:</td>
              <td>
                <span
                  class="font-weight-bold text-primary mx-2"
                  style="font-size: 20px"
                >
                  {{
                    item && item.data && item.data.listVideoRendering
                      ? item.data.listVideoRendering.length
                      : 0
                  }}
                </span>
              </td>
              <td>
                <v-icon
                  v-if="!item.isShow"
                  @click="listServer[index].isShow = true"
                  class="icon-show-detail mx-2"
                  >mdi-chevron-down-circle</v-icon
                >
                <v-icon
                  v-else
                  @click="listServer[index].isShow = false"
                  class="icon-hide-detail mx-2"
                >
                  mdi-chevron-up-circle
                </v-icon>
              </td>
            </tr>
          </table>

          <table
            v-if="
              item && item.isShow && item.data && item.data.listVideoRendering
            "
            class="table table-hover table-bordered table-sm text-center"
          >
            <thead>
              <th>ID Video</th>
              <th>Tên tài khoản</th>
            </thead>
            <tr v-for="(video, i) in item.data.listVideoRendering" :key="i">
              <td>
                {{ video._id }}
              </td>
              <td>
                {{ video.username }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <loading
        :active.sync="isLoading"
        :is-full-page="false"
        :width="50"
        :height="50"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import ServiceApi from "../services/ServiceApi";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      sidebar: false,
      keyTabBar: 0,
      isShowInfoServer: false,
      listServer: [],
      isLoading: false,
      listVideoQueuing: [],
      isShowVideoQueuing: false
    };
  },
  watch: {
    "$vuetify.breakpoint.name": {
      deep: true,
      handler() {
        this.keyTabBar++;
      }
    }
  },
  components: {
    Loading
  },
  computed: {
    listHeaderTitle() {
      let menuItems = [
        {
          text: "Bảng Giá",
          show: this.$store.state.isUserLoggedIn,
          path: "/pricing",
          icon: "mdi-cash-multiple"
        },
        {
          text: "Bảng Giá",
          show: !this.$store.state.isUserLoggedIn,
          path: "/pricing",
          icon: "mdi-cash-multiple"
        },
        {
          text: "Đăng nhập",
          show: !this.$store.state.isUserLoggedIn,
          path: "/signin",
          icon: "mdi-login-variant"
        },
        {
          text: "Chức Năng",
          show: this.$store.state.isUserLoggedIn,
          path: "/workflow",
          icon: "mdi-atom"
        },
        {
          text: "Danh sách Video",
          show: this.$store.state.isUserLoggedIn,
          path: "/manager-video",
          icon: "mdi-clipboard-list-outline"
        }
      ];
      return menuItems.filter(item => item.show);
    },
    ...mapGetters(["userData"])
  },
  mounted() {},
  methods: {
    async onClickServerRender() {
      this.isLoading = true;
      let listVideoQueuing = [];
      let listServer = [];
      try {
        this.isShowInfoServer = true;
        let res = await ServiceApi.getInfoServer();
        if (res && res.status === 200) {
          listServer = res.data.listServer;
          listVideoQueuing = res.data.listVideoQueuing;
        }
      } catch (error) {}

      listServer = listServer.map(item => {
        return { ...item, isShow: false };
      });
      this.listVideoQueuing = listVideoQueuing;
      this.listServer = listServer;
      this.isLoading = false;
    },
    signout() {
      this.$store.dispatch("setUser", null);
      this.$router.push("/signin");
      this.$swal.fire({
        icon: "success",
        title: "Logout successful",
        showConfirmButton: false,
        timer: 1000
      });
    }
  }
};
</script>

<style scoped>
.app-bar {
  box-shadow: 0px 1px 4px 1px #d9d9d9;
  z-index: 7 !important;
}
.avatar {
  -webkit-transition: all 0.3s ease-out 0s;
  -moz-transition: all 0.3s ease-out 0s;
  -ms-transition: all 0.3s ease-out 0s;
  -o-transition: all 0.3s ease-out 0s;
  object-fit: cover;
  width: 32px;
  height: 32px;
}

.navbar-brand.logo {
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
}

.navbar-brand.logo span {
  color: #ff5c97;
  border: 3px solid #ff5c97;
  border-radius: 6px;
  padding: 0px 5px;
}

.hover-header-title:hover {
  font-weight: bold !important;
  color: #000 !important;
}
.icon-show-detail {
  font-size: 23px !important;
  color: #04d435 !important;
}
.icon-live {
  color: red !important;
  padding: 5px !important;
}
.icon-die {
  color: #000 !important;
  padding: 5px !important;
}
.item-server {
  border: 1px solid #333 !important;
  padding: 5px !important;
  margin: 10px 0 10px 0 !important;
}
.icon-hide-detail {
  font-size: 23px !important;
  color: #555 !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Header.vue